import styled from "styled-components";

const Input = styled.input`
  display: none;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 24px;
  color: #fff;
  position: relative;
  cursor: pointer;

  &:before {
    content: "";
    display: block;
    width: 26px;
    height: 26px;
    border: 1px solid #e8e8e8;
    border-radius: 25px;
    background: #fff;
    opacity: 0.57;
    -webkit-box-sizing: unset;
    -moz-box-sizing: unset;
    box-sizing: unset;
    margin-right: 8px;
  }

  &:after {
    content: "";
    display: ${({ checked }: { checked: boolean }) =>
      checked ? "block" : "none"};
    position: absolute;
    bottom: 4px;
    left: 8px;
    width: 8px;
    height: 20px;
    transform: rotate(40deg);
    border-bottom: 4px solid #d8039f;
    border-right: 4px solid #d8039f;
    -webkit-box-sizing: unset;
    -moz-box-sizing: unset;
    box-sizing: unset;
  }
`;

const Radio = ({ value, checked, onClick, children }: any) => {
  return (
    <>
      <Input type="radio" />
      <Label onClick={() => onClick(value)} checked={value === checked}>
        {children}
      </Label>
    </>
  );
};

export default Radio;
